import { render, staticRenderFns } from "./ReviewSearchSelect.vue?vue&type=template&id=108b31c6&scoped=true"
import script from "./ReviewSearchSelect.vue?vue&type=script&lang=js"
export * from "./ReviewSearchSelect.vue?vue&type=script&lang=js"
import style0 from "./ReviewSearchSelect.vue?vue&type=style&index=0&id=108b31c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108b31c6",
  null
  
)

export default component.exports